var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextDeactiveicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V7L15 2Z",
    stroke: "url(#paint0_linear_8468_3748)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2V6C14 6.53043 14.2107 7.03914 14.5858 7.41421C14.9609 7.78929 15.4696 8 16 8H20",
    stroke: "url(#paint1_linear_8468_3748)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9H8",
    stroke: "url(#paint2_linear_8468_3748)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13H8",
    stroke: "url(#paint3_linear_8468_3748)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17H8",
    stroke: "url(#paint4_linear_8468_3748)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8468_3748",
    x1: 3.94441,
    y1: 2.63961,
    x2: 21.5497,
    y2: 4.16979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1504,
    stopColor: "#DC5385"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8468_3748",
    x1: 13.9792,
    y1: 2.19188,
    x2: 20.5534,
    y2: 2.90614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1504,
    stopColor: "#DC5385"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8468_3748",
    x1: 7.99305,
    y1: 9.03198,
    x2: 10.1104,
    y2: 9.49205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1504,
    stopColor: "#DC5385"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8468_3748",
    x1: 7.9722,
    y1: 13.032,
    x2: 13.0246,
    y2: 17.4233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1504,
    stopColor: "#DC5385"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8468_3748",
    x1: 7.9722,
    y1: 17.032,
    x2: 13.0246,
    y2: 21.4233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1504,
    stopColor: "#DC5385"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextDeactiveicon);
export default __webpack_public_path__ + "static/media/text-deactiveicon.35bb97248348178fb9de340a4d0aa8da.svg";
export { ForwardRef as ReactComponent };